import { render } from "./VerifyCode.vue?vue&type=template&id=4d197714&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"

import "./VerifyCode.vue?vue&type=style&index=0&id=4d197714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d197714"]])

export default __exports__